import dayjs from "dayjs";
import { Timestamp } from "firebase/firestore";

import { IMember } from "types";

const convertTimestampToDate = (timestamp?: Timestamp) => {
  if (timestamp) {
    // @ts-ignore
    if (timestamp._seconds) {
      // @ts-ignore
      return dayjs.unix(timestamp._seconds);
    }

    if (timestamp.seconds) {
      return dayjs.unix(timestamp.seconds);
    }
  }

  return dayjs();
};

/**
 * Detect is member has an active "Memberhip" (Monthly / Yearly)
 */
export const isActive = (member?: IMember) => {
  if (member) {
    if (member.membershipType === "Member") {
      if (member.membershipInterval) {
        const createdAt = convertTimestampToDate(member.createdAt);
        const currentDate = dayjs();

        switch (member.membershipInterval) {
          case "month": {
            const diff = currentDate.diff(createdAt, "month");
            return diff > 0 ? false : true;
          }

          case "year": {
            const diff = currentDate.diff(createdAt, "year");
            return diff > 0 ? false : true;
          }

          case "lifetime-giveaway": {
            return true;
          }

          default: {
            return false;
          }
        }
      }
    }
  }

  return false;
};
